<!-- vChain File Verification Copyright 2019 vChain Inc. -->
<template>
    <div class="overlay">
        <div class="overlay-text">
            <h1><i-icon icon="check" /></h1>
        </div>
    </div>
</template>

<script>
import { IIcon } from '@inkline/inkline/src/components';

export default {
    name: "DropOverlay",
    components: {
        IIcon
    }
};
</script>

<style scoped lang="scss">
.overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    background: rgba(#244583, 0.75);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 0;
    transition: opacity 0.3s ease;

    h1 {
        font-size: 24px;
        color: white;
        margin: 0;
    }

    &-active {
        opacity: 1;
    }

    &-text {
        text-align: center;
        width: 100%;
    }

    &.fixed {
        height: 100px;
    }
}
</style>
